/**
 * @desc 玩法标签
 * @author tankm
 * @since 2021-03-25 17:06:02
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './plugin-tag.less';

class PreviewPluginTag extends Component {
  static propTypes = {
    data: PropTypes.object,
    className: PropTypes.string,
  };

  render() {
    const { data, className } = this.props;
    const { pluginPlayWayTypes: tagList = [] } = data;
    return (
      Array.isArray(tagList) &&
      tagList.length > 0 && (
        <div className={cx('s-plugin-tag', className)}>
          <span>玩法：</span>
          <div className="s-plugin-tag-list">
            {tagList.map(tag => (
              <label className="s-plugin-tag-item" key={tag}>
                {tag}
              </label>
            ))}
          </div>
        </div>
      )
    );
  }
}

export default PreviewPluginTag;
